import React from 'react';

import { report } from "../../services/api";
import MainWindow from '../Wrappers/MainWindow';
import ReportHeader from './ReportHeader';
import Snapshots from './Snapshot/Snapshots';
import Spacer from './Spacer';
import Models from './Model/Models';
import Frame from './../Wrappers/Frame';
import StatisticsService from '../../services/StatisticsService';
import { AnalyticsService } from '../../services/AnalyticsService';
import './MonthlyResult.css';

interface Props {}

interface State {
  params: any;
  data?: {
    posts: Array<ReportPost>;
    models: Array<Model>;
    error: any;
    report: any;
    views: number;
    organic: number;
    inPerson: any;
  };
}

class MonthlyResult extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      params: {
        month: localStorage.getItem('pdf_render_month'),
        year: localStorage.getItem('pdf_render_year'),
      },
      data: {
        report: { title: '' },
        posts: [],
        models: [],
        organic: 0,
        inPerson: 0,
        error: null,
        views: 0,
      },
    };
    if (this.state.params.year) this.loadDate(this.state.params);
    document.title = 'Results • Neoncoat Brands Tool';
  }

  loadDate(date: MonthlyReportDate) {
    AnalyticsService.track('Switch report month', { date });
    report.monthly(date).then((data: any) => {
      this.setState({ data: data.data, params: date });
    });
  }

  render() {
    return (
      <MainWindow page="monthlyReport" wide={true}>
        <Frame title="" wide={true} hidePrint={true}>
          {this.state.data ? (
            <div style={{ width: '100%' }}>
              <div className="pdf-render" />
              <ReportHeader
                big={false}
                dates={this.state.params}
                loadDate={(date: MonthlyReportDate) => this.loadDate(date)}
                range=""
                report={this.state.data.report}
              />
              <Spacer />
              <Models
                models={this.state.data.models}
                views={StatisticsService.views(this.state.data.models, this.state.data.posts)}
                showInPerson={true}
              />
              <Spacer />
              <Snapshots
                posts={this.state.data.posts}
                organicCampaigns={this.state.data.organic}
                showInPerson={true}
              />
            </div>
          ) : (
            <div />
          )}
        </Frame>
      </MainWindow>
    );
  }
}

export default MonthlyResult;
